export default "__VITE_ASSET__5tcWLYAk__"